<template>
    <div class="news-wrapper">
        <div class="left-list scroll" v-if="hasLeft" ref="parent">
            <List ref="newsList" :detail="model" v-model="selectArticle" @change="handleSelectChange" />
        </div>
        <div class="right-content scroll" ref="articlceWrap">
            <Article v-if="rightRenderType === 'article'" ref="newsContent" />
            <iframe v-else :src="iframeUrl" title="公告" class="notice-iframe"></iframe>
        </div>
    </div>
</template>

<script>
import Article from "./components/Article";
import List from "@/pages/components/common_list";
import * as actions from "@/common/js/api";
export default {
    name: "news",
    data() {
        return {
            selectArticle: {},
            title: "",
            // 新增右侧渲染类型 article 为文章底层页 iframe 为公告链接
            rightRenderType: 'article' 
        };
    },
    provide() {
        return {
            selectArticle: () => this.selectArticle,
            pageDetail: { ...this.model },
        };
    },
    props: ["model"],
    components: {
        Article,
        List,
    },
    computed: {
        hasLeft() {
            return this.model.treeid || !!this.model.tagname;
        },
        iframeUrl() {
            const time = this.selectArticle.time || this.selectArticle.ctime;
            const id = this.filterId(this.selectArticle);
            if (!time) return '';
            return `//news.10jqka.com.cn/field/sr/${this.$utils.thscSnsBaselibUtils.formatTime(time, '{YYYY}{MM}{DD}')}/${id}.shtml#code=${this.model.code}`;
        }
    },
    beforeCreate: function () { },
    created: function () {
        // 迁移至common_list
        let { treeid, code, objid } = this.model;
        //this.$client.getSeqByObjid(objid, code, treeid).then((res) => {
        //    // console.log(`other`);
        //    this.$refs.newsList.handleItemClick(res);
        //});

        //只针对 上证，深证 指数
        if (this.model.code) {
            this.$client.getStockName(this.model.code).then((res) => {
                if (res[code]) {
                    this.title = res[code].ZQMC + "资讯";
                }
            });
        } else if (this.model.treeid == '14355') {
            this.$client.GetMainWindowCode().then((res) => {
                if (res) {
                    const newCode = res.split(':')[1]
                    if (newCode) {
                        this.$client.getStockName(newCode).then((res) => {
                            if (res[newCode]) {
                                this.title = res[newCode].ZQMC + "资讯";
                            }
                        });
                    }
                }
            }, () => {
                console.log(`客户端数据获取为空`);
            })
        } else {//无
        }
    },
    watch: {
        title: {
            handler(val) {
                this.takeThingsBack(this.title);
            },
        },
    },
    mounted: function () { },
    methods: {
        handleSelectChange(e) {
            this.selectArticle = e;
            console.log("e------", e);
            this.$project.saveHistory(e);
            const articleId = this.filterId(this.selectArticle);
            if (String(articleId).length > 8) {
                this.rightRenderType = 'article';
                // 等待下一次 DOM 更新后才能获取ref
                this.$nextTick(() => {
                    if (this.$refs.newsContent) {
                        this.$refs.newsContent.initData(e);
                    }
                });
            } else {
                this.rightRenderType = 'iframe';
            }
        },
        filterId(obj) {
            return obj.id || obj.seq;
        },
        // 向外部边框传递信息
        takeThingsBack(title, collectInfo) {
            this.$dispatch("basic", "LISTEN_CHILD", {
                method: "freshBaseInfo",
                data: {
                    componentName: this.model.componentName,
                    collectInfo,
                    title,
                },
            });
        },
    },
};
</script>
<style lang="less" scoped>
.notice-iframe {
    width: 100%;
    height: 100%;
}
@import '../common/page_common.less';
</style>
